// src/queries/getPlaces.ts
import datoCMSClient from './datoCMSClient';
import { Place } from '../types'; // Import the singular type 'Place'

const GET_PLACES = `
  query {
    allPlaces {
      title
      description
      image {
        url
      }
    }
  }
`;

// Fetches an array of Place objects
export async function getPlaces(): Promise<Place[]> {
  // Assuming DatoCMS returns data under 'allPlaces'
  const data = await datoCMSClient.request<{ allPlaces: Place[] }>(GET_PLACES);
  return data.allPlaces;
}